import React from 'react';

//Dependencies.
import { Outlet } from 'react-router-dom';

import './ChallengesPage.styles.css';

const ChallengesPage = () => <Outlet />

export default ChallengesPage

